import { createSelector } from 'reselect';

export const getToasts = (state) => state.toasts;
export const getAllToasts = createSelector(
    [getToasts],
    (toasts) => {
        const {
            success,
            info,
            warning,
            error
        } = toasts;
        const all = [...success, ...info, ...warning, ...error];
        return all.sort((a, b) => a.addedAt - b.addedAt);
    }
);
